import { origin } from "../stores/variables"
import { profileData } from "../stores/data"

export function logout(exit) {
	profileData.set("");
	if (exit) {
		window.location.href = origin + "auth/?logout=1";
	} else {
		window.location.href = origin + "auth/";
	}
}